import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Size } from '../discount/discount';

export const StyledRatingWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledRatingValueBox = styled.div<{ size: Size }>`
    background-color: ${(props) => props.theme.colors.main4};
    color: ${(props) => props.theme.shades.white};
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    ${(props) => {
        return props.size === 'M'
            ? css`
                  width: 60px;
                  height: 28px;
                  font-size: ${props.theme.fontSize.copyTextXL};
              `
            : css`
                  width: 47px;
                  height: 25px;
                  font-size: ${props.theme.fontSize.copyTextS};
              `;
    }}
`;

export const StyledArrow = styled.div`
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid ${(props) => props.theme.colors.main4};
`;

export const StyledRatingStringBox = styled.span`
    padding-left: 4px;
    line-height: 12px;
`;

export const StyledRatingString = styled.span`
    display: block;
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    font-weight: 700;
`;

export const StyledAmount = styled.span`
    font-size: ${(props) => props.theme.fontSize.copyTextXSS};
    font-weight: 400;
    white-space: nowrap;
`;
